import React, { useState } from "react";
import Card from "components/card";
import { MdClose, MdSearch } from "react-icons/md";
import { FaCar } from "react-icons/fa";

const VehicleSearchModal = ({ isOpen, onClose, onSearch }) => {
  const [searchData, setSearchData] = useState({
    pickupLocation: "",
    dropoffLocation: "",
    pickupDate: "",
    pickupTime: "",
    vehicleType: ""
  });

  const handleInputChange = (field, value) => {
    setSearchData(prev => ({ ...prev, [field]: value }));
  };

  const handleSearch = () => {
    onSearch(searchData);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-60 backdrop-blur-sm">
      <Card extra="w-[500px] bg-white/95 dark:bg-navy-800/95 backdrop-blur-sm border border-white/20 dark:border-navy-600/50 shadow-2xl">
        <div className="bg-[#5a88c6] shadow-lg p-6 rounded-t-[20px] relative overflow-hidden">
          <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full -translate-y-16 translate-x-16"></div>
          <div className="relative z-10 flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <div className="rounded-2xl bg-white/20 backdrop-blur-sm p-3">
                <FaCar className="h-6 w-6 text-white" />
              </div>
              <div>
                <h3 className="text-2xl font-bold text-white">Search Vehicles</h3>
                <p className="text-white/80 text-sm">Find the perfect vehicle for your trip</p>
              </div>
            </div>
            <button onClick={onClose} className="rounded-full bg-white/20 p-2 text-white hover:bg-white/30 transition-colors">
              <MdClose className="h-6 w-6" />
            </button>
          </div>
        </div>
        
        <div className="p-6 space-y-4">
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-semibold text-slate-700 dark:text-white mb-2">Pickup Location</label>
              <input
                type="text"
                value={searchData.pickupLocation}
                onChange={(e) => handleInputChange('pickupLocation', e.target.value)}
                placeholder="Enter pickup location"
                className="w-full px-4 py-3 border border-slate-200 dark:border-navy-600 bg-white dark:bg-navy-800 text-slate-900 dark:text-white rounded-xl text-sm focus:border-green-500 focus:outline-none transition-colors"
              />
            </div>
            <div>
              <label className="block text-sm font-semibold text-slate-700 dark:text-white mb-2">Drop-off Location</label>
              <input
                type="text"
                value={searchData.dropoffLocation}
                onChange={(e) => handleInputChange('dropoffLocation', e.target.value)}
                placeholder="Enter drop-off location"
                className="w-full px-4 py-3 border border-slate-200 dark:border-navy-600 bg-white dark:bg-navy-800 text-slate-900 dark:text-white rounded-xl text-sm focus:border-green-500 focus:outline-none transition-colors"
              />
            </div>
          </div>
          
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-semibold text-slate-700 dark:text-white mb-2">Pickup Date</label>
              <input
                type="date"
                value={searchData.pickupDate}
                onChange={(e) => handleInputChange('pickupDate', e.target.value)}
                className="w-full px-4 py-3 border border-slate-200 dark:border-navy-600 bg-white dark:bg-navy-800 text-slate-900 dark:text-white rounded-xl text-sm focus:border-green-500 focus:outline-none transition-colors"
              />
            </div>
            <div>
              <label className="block text-sm font-semibold text-slate-700 dark:text-white mb-2">Pickup Time</label>
              <input
                type="time"
                value={searchData.pickupTime}
                onChange={(e) => handleInputChange('pickupTime', e.target.value)}
                className="w-full px-4 py-3 border border-slate-200 dark:border-navy-600 bg-white dark:bg-navy-800 text-slate-900 dark:text-white rounded-xl text-sm focus:border-green-500 focus:outline-none transition-colors"
              />
            </div>
          </div>
          
          <div>
            <label className="block text-sm font-semibold text-slate-700 dark:text-white mb-2">Vehicle Type</label>
            <select
              value={searchData.vehicleType}
              onChange={(e) => handleInputChange('vehicleType', e.target.value)}
              className="w-full px-4 py-3 border border-slate-200 dark:border-navy-600 bg-white dark:bg-navy-800 text-slate-900 dark:text-white rounded-xl text-sm focus:border-green-500 focus:outline-none transition-colors"
            >
              <option value="">Select vehicle type</option>
              <option value="economy">Economy</option>
              <option value="compact">Compact</option>
              <option value="midsize">Midsize</option>
              <option value="fullsize">Full Size</option>
              <option value="luxury">Luxury</option>
              <option value="suv">SUV</option>
            </select>
          </div>
          
          <div className="flex space-x-3 pt-4">
            <button
              onClick={onClose}
              className="flex-1 px-6 py-3 border border-slate-300 dark:border-navy-600 text-slate-700 dark:text-white rounded-xl font-semibold hover:bg-slate-50 dark:hover:bg-navy-700 transition-colors"
            >
              Cancel
            </button>
            <button
              onClick={handleSearch}
              className="flex-1 px-6 py-3 bg-[#5a88c6] text-white rounded-xl font-semibold hover:bg-[#4a7bb6] transition-all duration-200 flex items-center justify-center space-x-2"
            >
              <MdSearch className="h-5 w-5" />
              <span>Search Vehicles</span>
            </button>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default VehicleSearchModal;